import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\Partners\CreateDossierIAssureController::__invoke
* @see app/Http/Controllers/Dossier/Partners/CreateDossierIAssureController.php
* @route '/api/dossier/{dossier}/iassure'
*/
const CreateDossierIAssureController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateDossierIAssureController.url(args, options),
    method: 'post',
})

CreateDossierIAssureController.definition = {
    methods: ["post"],
    url: '/api/dossier/{dossier}/iassure',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Dossier\Partners\CreateDossierIAssureController::__invoke
* @see app/Http/Controllers/Dossier/Partners/CreateDossierIAssureController.php
* @route '/api/dossier/{dossier}/iassure'
*/
CreateDossierIAssureController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return CreateDossierIAssureController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\Partners\CreateDossierIAssureController::__invoke
* @see app/Http/Controllers/Dossier/Partners/CreateDossierIAssureController.php
* @route '/api/dossier/{dossier}/iassure'
*/
CreateDossierIAssureController.post = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateDossierIAssureController.url(args, options),
    method: 'post',
})

export default CreateDossierIAssureController